import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EMPTY, mergeMap, Observable, of, OperatorFunction } from 'rxjs';

export type UploadEvent<T> =
  { type: 'progress'; progress: number } | { type: 'complete'; body: T };

export const trackUpload = <T>(): OperatorFunction<
  HttpEvent<T>,
  UploadEvent<T>
> =>
  mergeMap((event): Observable<UploadEvent<T>> => {
    if (event.type === HttpEventType.UploadProgress && event.total) {
      return of({
        type: 'progress',
        progress: Math.round((100 * event.loaded) / event.total),
      });
    }

    if (event.type === HttpEventType.Response) {
      return of({ type: 'complete', body: event.body as T });
    }

    return EMPTY;
  });
